import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { TermsConditionsStateModel } from './terms-conditions-state.model';

@State<TermsConditionsStateModel>({
	name: 'termsConditionsState'
})
@Injectable()
export class TermsConditionsState {
	@Selector()
	static completedByGuardian(state: TermsConditionsStateModel) {
		return state.termsConditionsForm.model.termsGuardian;
	}
}
